import { coreUrls } from '@/api/urls/core';

import { formatStringByKey } from '@/utilities/formatStringByKey';
import { setApiOptions } from '@/utilities/services';

import { ListResponse, RequestResponseType } from '../../../../models';

import { api } from '@/api/client';
import {
    GetProductBatteryByUUIDQueryParamType,
    ProductBatteryType,
    ProductsBatteryByVehicleFiltersQueryParamType
} from '@/server/services/core/productBattery/models';
import { AxiosPromise } from 'axios';

export const getProductsBatteryByVehicleFiltersService = (
    queryParam: ProductsBatteryByVehicleFiltersQueryParamType
): AxiosPromise<ListResponse<ProductBatteryType>> => {
    const options = setApiOptions(coreUrls.getProductsBatteryByVehicleFilters, { queryParam }, true);
    return api({ ...options, method: 'GET' });
};

export const getProductBatteryByUuidService = (
    uuid: string,
    queryParam?: GetProductBatteryByUUIDQueryParamType
): AxiosPromise<RequestResponseType<ProductBatteryType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.getProductBatteryByUuid, { uuid }), { queryParam }, true);
    return api({ ...options, method: 'GET' });
};
